import dynamic from 'next/dynamic'

import type { FC } from 'react'
import type { BlockContentComponent, HubspotForm, ProductsList } from '@/gen/sanity/schema'
import type { UnpackedSanityHeroBannerCarousel, UnpackedTextColumnImagesBanner } from '@/lib/queries/sanityQueryStrings'

const SanityHeroBanner = dynamic(() =>
  import('@/components/SanityComponent/SanityHeroBanner').then((mod) => mod.SanityHeroBanner)
)

const SanityProductsList = dynamic(() =>
  import('@/components/SanityComponent/SanityProductsList').then((mod) => mod.SanityProductsList)
)

const SanityBlockContent = dynamic(() =>
  import('@/components/SanityComponent/SanityBlockContent').then((mod) => mod.SanityBlockContent)
)

const TextColumnImagesBanner = dynamic(() =>
  import('@/components/SanityComponent/TextColumnImagesBanner').then((mod) => mod.TextColumnImagesBanner)
)

const SanityHubSpotFormComponent = dynamic(() =>
  import('@/components/SanityComponent/SanityHubSpotForm').then((mod) => mod.SanityHubSpotForm)
)

interface SanityComponentsProps {
  sanityComponent:
    | UnpackedSanityHeroBannerCarousel
    | ProductsList
    | BlockContentComponent
    | UnpackedTextColumnImagesBanner
    | HubspotForm
}

export const SanityComponent: FC<SanityComponentsProps> = ({ sanityComponent }) => {
  switch (sanityComponent._type) {
    case 'heroBannerCarousel':
      return <SanityHeroBanner sanityComponent={sanityComponent} />
    case 'productsList':
      return <SanityProductsList sanityComponent={sanityComponent} />
    case 'blockContentComponent':
      return <SanityBlockContent sanityComponent={sanityComponent} />
    case 'textColumnImagesBanner':
      return <TextColumnImagesBanner sanityComponent={sanityComponent} />
    case 'hubspotForm':
      return <SanityHubSpotFormComponent sanityComponent={sanityComponent} />
    default:
      return null
  }
}
